import React,{useCallback,useState,useEffect} from 'react'

import Post from './Post'
import ArticalSlider from './ArticalSlider'

import style from '../../../styles/mystyle.module.css'
import {Navbar} from '../Layout/Navbar'
import { useTranslation } from "next-i18next";
function AllDetails( props ) {
  const image = useCallback(
    callback => {
  
     
      props.callback(callback)
    },
    []
  );
 

  const { t } = useTranslation("common");

  return (
    <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>
      <Navbar showDownloadAppSection={true} exchangeAllCurrenciesCallBack={(res)=>(res)} currenciesCallBack={(res)=>(res)}>
      <br />
      <br />
      <br />
      <br />

      {props.entityId||props.entityId==0?<><Post blogId={props.entityId[0]}
      image={image}
       blogDetailsData={props.blogDetails}
     />
  
 
   <ArticalSlider blogId={props.entityId[0]}
      blogType={props.blogType}
       ShowHeader={true} 
       title={t("RelatedArtical")}
       
       /></>:""}
 
     </Navbar>
     
    </div>
  )
}

export default AllDetails
